import { render, staticRenderFns } from "./detail_summary.vue?vue&type=template&id=93eb9322&scoped=true"
import script from "./detail_summary.vue?vue&type=script&lang=js"
export * from "./detail_summary.vue?vue&type=script&lang=js"
import style0 from "./detail_summary.vue?vue&type=style&index=0&id=93eb9322&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eb9322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93eb9322')) {
      api.createRecord('93eb9322', component.options)
    } else {
      api.reload('93eb9322', component.options)
    }
    module.hot.accept("./detail_summary.vue?vue&type=template&id=93eb9322&scoped=true", function () {
      api.rerender('93eb9322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/detail_summary.vue"
export default component.exports